import { addMiddleware } from 'redux-dynamic-middlewares'
import { LngLat } from 'maplibre-gl'

import { UPDATE_GEONAME_INFO } from '@bikemap/js/integrations/geolocation'
import { mapBoundsUpdate, mapMove, mapZoom, setMapViewport } from './actions'

/** @typedef {import("@bikemap/js/map/features/Viewport").default} ViewportMapFeature */

/** @typedef {import("./reducers/mapViewport").MapViewportState} MapViewportState */

/**
 * Connect a map viewport feature to the common mapViewport and bounds state.
 * @param {ViewportMapFeature} viewport
 * @param {import("redux").Store<MapViewportState>} store
 * @returns {ViewportMapFeature} The given viewport instance
 */
export function connectViewport(viewport, store) {
    store.subscribe(() => {
        const { mapViewport } = store.getState()
        viewport.center = new LngLat(...mapViewport.center)
        viewport.zoom = mapViewport.zoom
    })

    viewport.addEventListener('move', e => {
        store.dispatch(mapMove(e.center.toArray()))
    })
    viewport.addEventListener('zoom', e => {
        store.dispatch(mapZoom(e.zoom))
    })
    viewport.addEventListener('boundschange', e => {
        const boundsArray = e.bounds.toArray()
        store.dispatch(mapBoundsUpdate(boundsArray[0].concat(boundsArray[1])))
    })
    viewport.addEventListener('implicitmove', ({ center }) => {
        store.dispatch(setMapViewport({ center: center.toArray() }))
    })
    viewport.addEventListener('implicitzoom', ({ zoom }) => {
        store.dispatch(setMapViewport({ zoom }))
    })

    addMiddleware(store => next => action => {
        if (action.type === UPDATE_GEONAME_INFO) {
            if (action.bounds) {
                viewport.fitBounds(action.bounds)
            }
        }
        return next(action)
    })

    return viewport
}
